'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * The PhaseThree Portal Application.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * We initialize the entire portal from this file. The routing, loading, and
                                                                                                                                                                                                                                                                   * routines are all managed by the React `Router` compoonent that handles
                                                                                                                                                                                                                                                                   * the loading of pages and inter-app navigation.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * @since 0.0.1
                                                                                                                                                                                                                                                                   * @package React
                                                                                                                                                                                                                                                                   */


require('babel-polyfill');

require('~/p3.js');

require('~/p3.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _MuiThemeProvider = require('material-ui/styles/MuiThemeProvider');

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _reactDom = require('react-dom');

var _reactTapEventPlugin = require('react-tap-event-plugin');

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _Base = require('~/_themes/Base');

var _Base2 = _interopRequireDefault(_Base);

var _Logo = require('~/_components/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _NoResultsView = require('~/_components/NoResultsView');

var _NoResultsView2 = _interopRequireDefault(_NoResultsView);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Needed for onTouchTap
(0, _reactTapEventPlugin2.default)();

/**
 * @type Global localized variables
 */
var p3 = _extends({}, $.PhaseThree);
var path = p3.path;

// Initialize our analytics
p3.analytics.init(_reactGa2.default);

// If there was no timezone, try to find one
if (!p3.timezone.length) import('moment').then(function (moment) {
    import('moment-timezone').then(function () {
        p3.timezone = moment.tz.guess();
    });
});

delete $.PhaseThree;

/**
 * Our primary component activator.
 *
 * In order to utilize the code splitting mechanisms provided by our bundler,
 * we do a half-around sidewind rendering setup to lazily load the app file
 * only when we need them, drastically saving on the main app file size.
 *
 * @since 0.0.11
 * @method appComponent
 * @param string key The component identifier key
 * @param function get The component retrieval function
 * @return object A react component
 */
function appComponent(key, get) {

    /**
     * The primary app component.
     *
     * Serving as the gateway to the rest of our application, the app component
     * facilitates the lazy loading of any given component dynamically.
     *
     * @since 0.0.11
     * @class App
     * @package React
     */
    var App = function (_React$Component) {
        _inherits(App, _React$Component);

        /**
         * Component class constructor.
         *
         * Here we set the initial state of the component and make sure we have
         * the values we need to load the proper child component.
         *
         * @param object props The component properties
         * @param object context The component context
         */
        function App(props, context) {
            _classCallCheck(this, App);

            // Declare and initialize
            var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));

            // We call `super` to define `this`


            _initialiseProps.call(_this);

            var themeSet = p3.theme.themeSet || 'standard';
            var view = p3.theme.view || 'list';
            var theme = (0, _Base2.default)(p3.theme, view, null, themeSet);

            // Set the update handler
            p3.update = _this.handleUpdate;

            // Set the initial state
            _this.state = {
                key: key,
                app: null,
                loading: true,
                theme: theme
            };

            return _this;
        }

        /**
         * Component pre-mount routine.
         *
         * Right before the component mounts, we are going to make sure it has
         * the right application to load.
         *
         * @since 0.0.11
         * @method componentWillMount
         */


        _createClass(App, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var _this2 = this;

                // Declare and initialize
                var s = this.state;
                var router = this.props;
                var app = s.app || null;

                // If we already have an application, do not bother
                if (app) return;

                // Maybe we can do loading here?
                this.setState({ loading: true }, function () {
                    return get().then(function (app) {
                        return _this2.setState({ app: app, loading: false }, function () {

                            // Determine our page
                            var page = '';
                            var location = window.location.pathname;
                            var indexRoute = ~['login', 'dashboard'].indexOf(key);
                            var isIndex = location === p3.path + '/';

                            // For index pages, set the page manually
                            if (indexRoute && isIndex) page = key;

                            // Record this page view
                            p3.analytics.pageView(page);
                        });
                    });
                });
            }

            /**
             * Define the context for all children.
             *
             * Instead of passing global constants down the grapevine, we set the
             * context of each child component in one place.
             *
             * @since 0.0.11
             * @method getChildContext
             * @return object The child component context
             */


            /**
             * Handle child changes to the overall theme.
             *
             * There are times when the child must change the contents of th global
             * object (e.g., when we are changing colors or logos) that must be
             * carried on to all of the other apps.
             *
             * @since 0.3.6 Moved to the context of the dynamic app.
             *
             * @since 0.0.6
             * @method handleUpdate
             * @param string key The global variable to change
             * @param mixec val The new global variable value
             * @return void
             */

        }, {
            key: 'render',


            /**
             * Render the component content.
             *
             * Here we render out the application that we need. There is some trick
             * shot foolery that occurs in order to load our context component.
             *
             * @since 0.0.11
             * @method render
             * @package React
             * @return string Markup representation of component content
             */
            value: function render() {
                // Declare and initialize
                var s = this.state;
                var p = this.props;
                var key = s.key;
                var Component = s.app || null;
                var theme = s.theme || {};
                var globals = p3.globals || {};
                var activeApps = p3.activeApps;
                var isMobile = p3.viewport.isSmall();

                // Set our global active app to the current key
                p3.app.active = key;

                // Define our active apps
                var active = {
                    'announcements': p3.app.isActive(activeApps, 'announcements'),
                    'classifieds': p3.app.isActive(activeApps, 'classifieds'),
                    'clubs': p3.app.isActive(activeApps, 'clubs'),
                    'documents': p3.app.isActive(activeApps, 'documents'),
                    'errors': true,
                    'events': p3.app.isActive(activeApps, 'events'),
                    'frontend': p3.app.isActive(activeApps, 'frontend'),
                    'knowledge-base': p3.app.isActive(activeApps, 'knowledge-base'),
                    'tasks': p3.app.isActive(activeApps, 'tasks'),
                    'users': p3.app.isActive(activeApps, 'users'),
                    'work-orders': p3.app.isActive(activeApps, 'work-orders')
                };

                // If we are loading show a loading thing
                if (s.loading) {

                    // Define the progress color
                    var palette = theme.palette || {};
                    var color = palette.primary1Text;

                    // Define styles for the message
                    var messageStyle = {
                        position: 'relative',
                        top: -24,
                        fontSize: isMobile ? 16 : 20,
                        color: color
                    };

                    // Define our loading messaage
                    var msg = _react2.default.createElement(
                        'div',
                        { style: messageStyle },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                p3.text.decode(p3.siteName)
                            )
                        ),
                        'Loading, please wait...'
                    );

                    // Return a simple "no results" view
                    return _react2.default.createElement(
                        _MuiThemeProvider2.default,
                        { muiTheme: theme },
                        _react2.default.createElement(
                            'div',
                            { style: { position: 'relative', top: 96 } },
                            _react2.default.createElement('div', { style: theme.primaryBg }),
                            _react2.default.createElement(_NoResultsView2.default, { theme: theme, loading: true,
                                message: msg, progressColor: color,
                                relative: true })
                        )
                    );
                }

                // If the app can be disabled, see if it is disabled
                if (key && key in active && !active[key]) return _react2.default.createElement(_reactRouterDom.Redirect, { to: p3.link('404') });

                // If our app exists, mount it
                if (Component) return _react2.default.createElement(
                    'div',
                    { style: { color: theme.palette.textColor } },
                    _react2.default.createElement(Component, { p3: p3, globals: globals, router: _extends({}, p),
                        handleGlobalChange: this.handleUpdate })
                );

                // Otherwise return nothing
                return null;
            }
        }]);

        return App;
    }(_react2.default.Component);

    /**
     * Define our context values.
     *
     * Context values are passed down through the grapevine automatically. It saves
     * us from having to include parameters with every single iteration. Context
     * basically serves as a stand-in for global variables.
     *
     * @since 0.0.11
     * @type object
     */


    var _initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.getChildContext = function () {
            // Define our context
            return { p3: p3, router: _this3.props, theme: _this3.state.theme };
        };

        this.handleUpdate = function (key, val) {

            // We handle key changes explicitly
            switch (key) {
                case 'activeApps':
                    p3.activeApps = val;
                    break;

                case 'apps':
                    p3.globals.apps = val;
                    break;

                case 'theme':
                    // Set up the new theme values
                    p3.theme = _extends({}, p3.theme, val);

                    // Discern our new theme set
                    var themeSet = p3.theme.themeSet || 'standard';
                    var view = p3.theme.view || 'list';
                    var drawer = null;

                    // If a drawer value was set, use it
                    if (val && 'drawerOpen' in val) drawer = val.drawerOpen;

                    // Run the theme update
                    var theme = (0, _Base2.default)(p3.theme, view, drawer, themeSet);

                    // Impose the theme set
                    theme.themeSet = themeSet;

                    // Update the state
                    _this3.setState({ theme: theme });
                    break;

                case 'users':
                    p3.users = val;
                    p3.usersUpdate = moment();
                    break;

                case 'user':
                    p3.user = val;
                    renderAll();
                    break;

                case 'userAvatar':
                    p3.user.avatar = val;
                    break;

                case 'userProfile':
                    p3.user = $.extend(true, {}, val);
                    break;
            }
        };
    };

    App.childContextTypes = {
        p3: _propTypes2.default.object,
        router: _propTypes2.default.object,
        theme: _propTypes2.default.object
    };

    // Return our main application
    return App;
}

/**
 * Our portal applications.
 *
 * We define our portal applications as instances of our app component in order
 * to load them only when required.
 *
 * @since 0.0.11
 */
var Dashboard = appComponent('dashboard', function () {
    return import('~/dashboard/DashboardApp').then(function (app) {
        return app.default;
    });
});
var Announcements = appComponent('announcements', function () {
    return import('~/announcements/AnnouncementApp').then(function (app) {
        return app.default;
    });
});
var Errors = appComponent('errors', function () {
    return import('~/errors/ErrorApp').then(function (app) {
        return app.default;
    });
});
var Events = appComponent('events', function () {
    return import('~/events/EventApp').then(function (app) {
        return app.default;
    });
});
var Documents = appComponent('documents', function () {
    return import('~/documents/DocumentApp').then(function (app) {
        return app.default;
    });
});
var Classifieds = appComponent('classifieds', function () {
    return import('~/classifieds/ClassifiedApp').then(function (app) {
        return app.default;
    });
});
var Clubs = appComponent('clubs', function () {
    return import('~/clubs/ClubApp').then(function (app) {
        return app.default;
    });
});
var Frontend = appComponent('frontend');
var KnowledgeBase = appComponent('knowledge-base', function () {
    return import('~/knowledge-base/KnowledgeBaseApp').then(function (app) {
        return app.default;
    });
});
var Login = appComponent('login', function () {
    return import('~/login/LoginApp').then(function (app) {
        return app.default;
    });
});
var NotFound = appComponent('not-found', function () {
    return import('~/utility/NotFoundApp').then(function (app) {
        return app.default;
    });
});
var Settings = appComponent('settings', function () {
    return import('~/settings/SettingApp').then(function (app) {
        return app.default;
    });
});
var Tasks = appComponent('tasks', function () {
    return import('~/tasks/TaskApp').then(function (app) {
        return app.default;
    });
});
var Users = appComponent('users', function () {
    return import('~/users/UserApp').then(function (app) {
        return app.default;
    });
});
var WorkOrders = appComponent('work-orders', function () {
    return import('~/work-orders/WorkOrderApp').then(function (app) {
        return app.default;
    });
});

/**
 * The primary applicatoin rendering routine.
 *
 * Instead of having a flat render function call, we have a rendering routine
 * that can be recalled whenever the routes of our app change, such as when
 * we are going from a logged-out state to one that is authenticated. In
 * addition, it gives us a place to re-reference global values that may
 * affect the rendering of apps in one way or another.
 *
 * Note: We use a deliberately check for `guest` and `authenticated` to save
 *       processing time by not having to load the `guest` nodes when we
 *       are already `authenticated`.
 *
 * @since 0.0.7
 * @method renderAll
 * @return void
 */
var renderAll = function renderAll() {
    // Declare and initialize
    var routes = [];
    var authenticated = p3.user && 0 < p3.user.ID;
    var guest = !p3.user || 1 > p3.user.ID;
    var key = authenticated ? 'authenticated' : 'guest';

    // Logroll
    p3.log('We are rendering our application.', 'state');

    /**
     * Fire up the application for users that are not logged in.
     *
     * When the user is not logged in, we do not even bother activating any apps
     * other than the ones they need to login and be a stand-up member of the
     * site society for gifted children.
     *
     * @since 0.0.7
     */
    if (guest) routes = guestRoutes();

    /**
     * Fire up the application for users that were authenticated.
     *
     * All of our view rendering is based off of the router component provided
     * by React. It syncs up our address bar URI and the content on the page.
     *
     * @since 0.0.11 We are implementing a `Switch` component so that not all
     *               of the matching routes are activated.
     *
     * @since 0.0.7
     */
    else if (authenticated) routes = authenticatedRoutes();

        /**
         * Throw in an error if no routes could be found for whatever reason.
         *
         * @since 0.7.1
         */
        else routes = errorRoutes();

    // Render our authenticated components
    (0, _reactDom.render)(_react2.default.createElement(
        _reactRouterDom.BrowserRouter,
        { key: key },
        _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            routes
        )
    ), document.getElementById('app'));
};

/**
 * Return the error application set.
 *
 * @since 0.7.1
 * @method errorRoutes
 * @return void
 */
var errorRoutes = function errorRoutes() {
    // Logroll
    p3.log('We are rendering error components.', 'state');

    // Get the current location
    var here = 'redirect=' + window.location.pathname;
    var redirect = p3.link('', here);

    // Define and return the routes for the unauthenticated user
    return [
    /**
     * The Error App
     *
     * @since 0.7.1
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'index', path: p3.link(), exact: true,
        component: Errors }), _react2.default.createElement(_reactRouterDom.Redirect, { key: 'redirect', from: p3.link('*'), to: redirect })];
};

/**
 * Return the unauthenticated application set.
 *
 * When the user is not logged in, we do not even bother running some of our
 * methods and routines because an authorized user is required for them to
 * return valid results. To this end we provide a separate declaration of
 * rendered elements for users before they are authenticated.
 *
 * @since 0.0.7
 * @method guestRoutes
 * @return void
 */
var guestRoutes = function guestRoutes() {
    // Logroll
    p3.log('We are rendering guest components.', 'state');

    // Get the current location
    var here = 'redirect=' + window.location.pathname;
    var redirect = p3.link('', here);

    // Define and return the routes for the unauthenticated user
    return [
    /**
     * The Login/Registration App
     *
     * @since 0.0.7
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'index', path: p3.link(), exact: true, component: Login }), _react2.default.createElement(_reactRouterDom.Route, { key: 'login', path: p3.link('login'), component: Login }), _react2.default.createElement(_reactRouterDom.Route, { key: 'register', path: p3.link('register'), exact: true,
        component: Login }), _react2.default.createElement(_reactRouterDom.Route, { key: 'forgot', path: p3.link('forgot*'), exact: true,
        component: Login }), _react2.default.createElement(_reactRouterDom.Redirect, { key: 'root-login', from: '*login*', to: p3.link('login') }), _react2.default.createElement(_reactRouterDom.Redirect, { key: 'redirect', from: p3.link('*'), to: redirect })];
};

/**
 * Return the authenticated application set.
 *
 * Once we have determined that a user is authentic (or if the user has cookies
 * that signify authentication was previously successful) we can start the
 * rendering process for the primary components of our application.
 *
 * @since 0.0.7
 * @method authenticatedRoutes
 * @return void
 */
var authenticatedRoutes = function authenticatedRoutes() {
    // Double check the authentication
    if (!p3.user || 1 > p3.user.ID) return guestRoutes();

    // Logroll
    p3.log('We are rendering authenticated user components.', 'state');

    // Define our routes
    var routes = [

    /**
     * The Dashboard App
     *
     * @since 0.0.8
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'index', path: p3.link(), exact: true,
        component: Dashboard }), _react2.default.createElement(_reactRouterDom.Route, { key: 'dashboard', path: p3.link('dashboard'), exact: true,
        component: Dashboard }),

    /**
     * The Announcements App
     *
     * @since 0.0.8
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'announcements', path: p3.link('announcements'),
        component: Announcements }),

    /**
     * The Classifieds App
     *
     * @since 0.1.1
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'classifieds', path: p3.link('classifieds*'),
        component: Classifieds }),

    /**
     * The Clubs App
     *
     * @since 0.1.1
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'clubs', path: p3.link('clubs*'), component: Clubs }),

    /**
     * The Clubs App
     *
     * @since 0.7.0
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'documents', path: p3.link('documents*'),
        component: Documents }),

    /**
     * The Events App
     *
     * @since 0.1.1
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'events', path: p3.link('events*'), component: Events }),

    /**
     * The Frontend Resources App
     *
     * @since 0.1.1
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'frontend', path: p3.link('frontend*'),
        component: Frontend }),

    /**
     * The Knowledge Base App
     *
     * @since 0.0.10
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'knowledge-base', path: p3.link('knowledge-base*'),
        component: KnowledgeBase }),

    /**
     * The Tasks App
     *
     * @since 0.0.9
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'tasks', path: p3.link('tasks'), component: Tasks }),

    /**
     * The Work Orders App
     *
     * @since 0.0.3
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'work-orders', path: p3.link('work-orders*'),
        component: WorkOrders }),

    /**
     * The Users App
     *
     * @since 0.0.5
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'users', path: p3.link('users'), component: Users }),

    /**
     * The Settings App
     *
     * @since 0.0.7
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'settings', path: p3.link('settings'),
        component: Settings }),

    /**
     * Redirection
     *
     * @since 0.0.11
     */
    _react2.default.createElement(_reactRouterDom.Redirect, { key: 'root-login', from: '*login*', to: p3.link() }), _react2.default.createElement(_reactRouterDom.Redirect, { key: 'redirect', from: p3.link('login'), to: p3.link() }), _react2.default.createElement(_reactRouterDom.Redirect, { key: 'redirect', from: p3.link('register'), to: p3.link() }),

    /**
     * The Not Found App
     *
     * @since 0.0.11
     */
    _react2.default.createElement(_reactRouterDom.Route, { key: 'not-found-default', path: p3.link('*'),
        component: NotFound })];

    // Return the specified routes
    return routes;
};

// Run the initial rendering call
renderAll();


//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 298
// module chunks = 7